import { makeVar } from "@apollo/client";
import { GetMeQueryType } from "../__generated___/gql";

export const setMe = makeVar<GetMeQueryType["me"][0] | undefined>(undefined);
